import type { IconSvgObject } from './types';

const TextFootnoteIcon: IconSvgObject = [
  ["path", { d: "M11.5 21H6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 2.99998L9 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 5.49998V3.99998C2 3.4477 2.44772 2.99998 3 2.99998H15C15.5523 2.99998 16 3.4477 16 3.99998V5.49998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M19.9999 8.39998L22 7.19998M19.9999 8.39998L18 7.19998M19.9999 8.39998L18.3999 9.99998M19.9999 8.39998L21.5999 9.99998M19.9999 8.39998L20 5.99998", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default TextFootnoteIcon;
